import { render, staticRenderFns } from "./EmailPhoneSetting.vue?vue&type=template&id=406ec87e&scoped=true"
import script from "./EmailPhoneSetting.vue?vue&type=script&lang=js"
export * from "./EmailPhoneSetting.vue?vue&type=script&lang=js"
import style0 from "./EmailPhoneSetting.vue?vue&type=style&index=0&id=406ec87e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406ec87e",
  null
  
)

export default component.exports